export const GENERIC_ERROR_MESSAGE =
  "Failed - Due to Technical error, Please try again";

/**
 * action type constants related to fetching the default models List
 */
export const FETCH_MODEL_LIST_REQUEST = "FETCH_MODEL_LIST_REQUEST";
export const FETCH_MODEL_LIST_SUCCESS = "FETCH_MODEL_LIST_SUCCESS";
export const FETCH_MODEL_LIST_ERROR = "FETCH_MODEL_LIST_ERROR";
export const ON_BOARD_MODEL_INFO = "ON_BOARD_MODEL_INFO";
export const IMAGE_PREVIEW_POPUP_OPEN = "IMAGE_PREVIEW_POPUP_OPEN";
export const IMAGE_PREVIEW_POPUP_CLOSE = "IMAGE_PREVIEW_POPUP_CLOSE";
export const CONFIRM_SAVE_POPUP_TITLE = "INSTRUMENT MODEL ONBOARD";
export const SAVE_CONFIRM_POPUP_OPEN = "SAVE_CONFIRM_POPUP_OPEN";
export const SAVE_CONFIRM_POPUP_CLOSE = "SAVE_CONFIRM_POPUP_CLOSE";
export const CANCEL_CONFIRM_POPUP_OPEN = "CANCEL_CONFIRM_POPUP_OPEN";
export const CANCEL_CONFIRM_POPUP_CLOSE = "CANCEL_CONFIRM_POPUP_CLOSE";
export const ONBOARD_INSTRUMENT_JSON = "ONBOARD_INSTRUMENT_JSON";
export const INSTRUMENT_MODEL_REQUEST = "INSTRUMENT_MODEL_REQUEST";
export const INSTRUMENT_MODEL_SUCCESS = "INSTRUMENT_MODEL_SUCCESS";
export const INSTRUMENT_MODEL_ERROR = "INSTRUMENT_MODEL_ERROR";
export const CLOSE_SUCCESS_MESSAGE_POPUP = "CLOSE_SUCCESS_MESSAGE_POPUP";
export const CLOSE_ERROR_MESSAGE_POPUP = "CLOSE_ERROR_MESSAGE_POPUP";
export const FETCH_INSTRUMENT_CONFIG = "FETCH_INSTRUMENT_CONFIG";
export const GENERIC_FAILED_ERROR =
  "Connection timed out. Please try again after some time.";
export const SAVE_CONFIRMATION_MESSAGE = "Click Ok to confirm changes";
export const DELAYED_CONFIRMATION_MESSAGE = "Onboarding New model configurations may take sometime. Click Ok to confirm changes";

export const CANCEL_CONFIRMATION_MESSAGE =
  "Are you sure, You want to cancel changes";
export const MANDATORY_ABSOLUTE_PATH = "Enter Absolute path";

export const VALID_ABSOLUTE_PATH = "Enter valid absolute path";

export const MANDATORY_MODEL_NAME = "Select Instrument Model";
export const MANDATORY_IMAGE = "Upload Instrument Image";
export const ONLY_PNG_IMAGE = "Upload only .png image";
export const FIX_IMAGE_SIZE = "Image size should be less than 1 MB";
export const PNG_IMAGE_TYPE = "image/png";

export const CLEAR_CONTENT = "CLEAR_CONTENT";
export const FETCH_MODEL_DATA_REQUEST = "FETCH_MODEL_DATA_REQUEST";
export const FETCH_MODEL_DATA_SUCCESS = "FETCH_MODEL_DATA_SUCCESS";
export const FETCH_MODEL_DATA_ERROR = "FETCH_MODEL_DATA_ERROR";
export const ON_MODEL_LOAD = "ON_MODEL_LOAD";
export const IMAGE_LENGTH = 30
export const GENERIC_MESSAGE = "Failed due to a technical error, please try again later";
export const ELEMENT_FOCUS = "ELEMENT_FOCUS";
export const FILTERED_AUTOCOMPLETE_VALUES = "FILTERED_AUTOCOMPLETE_VALUES";
export const ADD_SUGGESTIONS = "ADD_SUGGESTIONS"
export const TRACKING = "TRACKING"


